
import Vue from "vue";
import filters from "@/filters";
import Component from "vue-class-component";
import { Action, State } from "vuex-class";
import axios, { AxiosResponse } from "axios";
import { SCHOOL_PARTNERSHIP } from "@/constants/enum.constant";
import { SchoolModel } from "@/models/academy.model";
import ModalApproveExtend from "@/views/apps/partnership/ModalApproveExtend.vue";
import ModalReject from "@/views/apps/partnership/ModalReject.vue";
import { saveAs } from "file-saver";

@Component({
  components: {
    ModalReject,
    ModalApproveExtend
  },
  filters,
})
export default class Review extends Vue {
  @Action("actionGetDetail", { namespace: "partnership" })
  private actionGetDetail: any;
  @Action("actionGetAgreement", { namespace: "partnership" })
  private actionGetAgreement: any;

  @State("locale")
  private locale: any;
  @State("school", { namespace: "academy" })
  private school: SchoolModel;

  private modalApprove: boolean = false;
  private modalReject: boolean = false;
  private currentId: number = 0;
  private currentTempId: number = 0;
  private company: any = null;

  private get getLogo() {
    return this.company.company_logo || this.company.logo || require("@/assets/Photo/photo_placeholder-company.jpg");
  }

  private mounted() {
    this.getData();
  }

  private approve() {
    this.modalApprove = true;
    this.setApproval();
  }
  private reject() {
    this.modalReject = true;
    this.setApproval();
  }
  private setApproval() {
    this.currentId = this.company.partnerships[0].company_id || 0;
    this.currentTempId = this.company.partnerships[0].company_temporary_id || 0;
  }

  private getData() {
    this.actionGetDetail({
      params: {
        id: this.$route.params.id,
        temp_id: this.$route.params.temp_id
      },
      success: (response: AxiosResponse) => {
        this.company = response.data;
      },
    });
  }

  private redirect() {
    if (this.$route.params.id) this.$router.push({name: "partnership-detail", params: {id: this.$route.params.id}});
    else this.$router.push({name: "partnership"});
  }

  private getBadge (status: number) {
    if (status === SCHOOL_PARTNERSHIP.PENDING) return require("@/assets/images/partnership/pending.png")
    else if (status === SCHOOL_PARTNERSHIP.REJECTED) return require("@/assets/images/partnership/rejected.png")
    else if (status === SCHOOL_PARTNERSHIP.EXPIRED) return require("@/assets/images/partnership/expired.png")
    else return require("@/assets/images/partnership/verified.png")
  }

  private getIndustryName(data: any) {
    if (data) {
      if (this.locale === "id") return data.translation;
      return data.name;
    } else {
      return "-";
    }
  }

  private getAgreement () {
    this.actionGetAgreement({
      params: {
        path: this.school.subpath
      },
      success: (response: AxiosResponse) => {
        this.download(response.data.agreement_doc);
      },
    });
  }

  private download (url: string) {
    const filename = `Agreement Document.${url.split(".").pop()}`;
    axios.get(url, {responseType: "blob"})
      .then((res) => {
        saveAs(res.data, filename);
      })
      .catch((e) => console.warn("Unable to download file!", e));
  }
}
